/**! useragentLite.js | v2.2.0 | @license Copyright (C) 2021 - 2025 Taichi Matsutaka | RENDAN */
/**
 *
 * @name    : useragentLite.js
 * @content : useragentLite
 * @url     : https://github.com/taichaaan/js-useragent
 * @creation: 2021.10.26
 * @update  : 2025.09.12
 * @version : 2.2.0
 *
 */
class uaLite {
	constructor(options) {

		/**************************************************************
		 * defaults options
		**************************************************************/
		const defaults = {
			device    : true,
			deviceType: true,
			browser   : true,
			display   : true,
			hover     : true,
		};


		/**************************************************************
		 * options
		**************************************************************/
		this.options = { ...defaults, ...options };


		/**************************************************************
		 * init
		**************************************************************/
		this.ua = {};

		this.judgment();
		this.addClass();
		// this.check();
	}

	judgment() {
		/*
		 * 判定
		 * いろいろ判定する
		 */
		const ua           = navigator.userAgent.toLowerCase();
		const isTouchstart = window.ontouchstart === null ? "touchstart" : "click";


		/**************************************************************
		 * deviceType
		**************************************************************/
		this.ua.deviceType = (() => {
			const isTablet =
				(
					ua.indexOf("windows") !== -1 &&
					ua.indexOf("touch") !== -1 &&
					ua.indexOf("tablet pc") == -1
				)||
				ua.indexOf("ipad") !== -1|| (ua.indexOf("android") !== -1 &&
				ua.indexOf("mobile") == -1)||  (ua.indexOf("firefox") !== -1 &&
				ua.indexOf("tablet") !== -1)|| ua.indexOf("kindle") !== -1|| ua.indexOf("silk") !== -1|| ua.indexOf("playbook") !== -1;
			const isSmartphone =
				(
					ua.indexOf("windows") !== -1 &&
					ua.indexOf("phone") !== -1
				) ||
				ua.indexOf("iphone") !== -1 || ua.indexOf("ipod") !== -1 || (ua.indexOf("android") !== -1 &&
				ua.indexOf("mobile") !== -1) || ( ua.indexOf("firefox") !== -1 &&
				ua.indexOf("mobile") !== -1) || ua.indexOf("blackberry") !== -1;

			if      ( isSmartphone && isTouchstart == 'touchstart' ) return ['smartphone'];
			else if ( isTablet && isTouchstart == 'touchstart' ) return ['tablet'];
			else if ( isTouchstart == 'click' ) return ['pc'];
			else if ( isTouchstart == 'touchstart' ) return ['tablet'];
		})();


		/**************************************************************
		 * device
		**************************************************************/
		this.ua.device = (() => {
			if      ( ua.indexOf('mac') > -1 && !('ontouchend' in document) ) return ['mac'];
			else if ( ua.indexOf('iphone') !== -1 || ua.indexOf('ipod') !== -1 ) return ['iphone'];
			else if ( ua.indexOf('ipad') !== -1 || ua.indexOf('mac') !== -1 && isTouchstart == 'touchstart' ) return ['ipad-mac'];
			else if ( ua.indexOf('ipad') !== - 1) return ['ipad'];
			else if ( ua.indexOf('android') !== -1 ) return ['android'];
			else if ( ua.indexOf('windows') !== -1 && ua.indexOf('phone') !== -1 ) return ['windows-phone'];
			else if ( ua.indexOf('windows') !== -1 ) return ['windows'];
			else return -1;
		})();



		/**************************************************************
		 * browser
		**************************************************************/
		this.ua.browser = (() => {
			if      ( ua.indexOf('edge') !== -1 ) return ['edge'];
			else if ( ua.indexOf("edga") !== -1 ) return ['edga'];
			else if ( ua.indexOf("edgios") !== -1 ) return ['edgios'];
			else if ( ua.indexOf("edg") !== -1 ) return ['edg'];
			else if ( ua.indexOf("iemobile") !== -1 ) return ['iemobile'];
			else if ( ua.indexOf('trident/7') !== -1 ) return ['ie','ie11'];
			else if ( ua.indexOf("msie") !== -1 && ua.indexOf('opera') === -1 ){
				if    ( ua.indexOf("msie 10.") !== -1 ) return ['ie','ie10'];
				else if ( ua.indexOf("msie 9.")  !== -1 ) return ['ie','ie9'];
				else if ( ua.indexOf("msie 8.")  !== -1 ) return ['ie','ie8'];
				else return -1;
			}
			else if ( ua.indexOf('crios')   !== -1 ) return ['crios'];
			else if ( ua.indexOf('gsa')     !== -1 ) return ['gsa'];
			else if ( ua.indexOf('yahoo')   !== -1 ) return ['yahoo'];
			else if ( ua.indexOf('fxios')   !== -1 ) return ['fxios'];
			else if ( ua.indexOf('firefox') !== -1 ) return ['firefox'];
			else if ( ua.indexOf('safari')  !== -1 && ua.indexOf('chrome') === -1 ) return ['safari'];
			else if ( ua.indexOf('chrome')  !== -1 && ua.indexOf('edge') === -1 )   return ['chrome'];
			else if ( ua.indexOf('opera')   !== -1 ) return ['opera'];
			else return -1;
		})();



		/**************************************************************
		 * display
		 * DPR を 0.25 刻みで丸める
		**************************************************************/
		this.ua.display = (() => {
			const classes = [];

			const dprRaw   = window.devicePixelRatio || 1;
			const quantize = (v, step) => Math.round(v / step) * step;
			const dprQ     = quantize(dprRaw, 0.25);

			const dprStr = dprQ.toFixed(2).replace(/\.?0+$/, '');

			classes.push(`dp-${dprStr.replace(/\./g, '-')}`);
			classes.push(`dp-${dprStr}`);

			// 画面サイズ（CSSピクセル）
			// const cssW = window.screen.width;
			// const cssH = window.screen.height;
			// classes.push(`css-${cssW}-${cssH}`);

			// “物理解像度相当” ≒ CSSピクセル × DPR
			// const phyW = Math.round(cssW * dprRaw);
			// const phyH = Math.round(cssH * dprRaw);
			// classes.push(`phy-${phyW}-${phyH}`);
			// classes.push(`phw-${phyW}`); // 幅のみ

			// よく使う解像度帯（bucket）
			// let bucket = 'hd';
			// if      (phyW >= 7680) bucket = '8k';
			// else if (phyW >= 5120) bucket = '5k';
			// else if (phyW >= 3840) bucket = '4k';
			// else if (phyW >= 3440) bucket = 'uwqhd';
			// else if (phyW >= 2560) bucket = 'wqhd';
			// else if (phyW >= 1920) bucket = 'fhd';
			// else if (phyW >= 1280) bucket = 'wxga';
			// classes.push(`res-${bucket}`);

			return classes.length ? classes : -1;
		})();



		/**************************************************************
		 * hover
		**************************************************************/
		this.ua.hover = (() => {
			if( window.matchMedia('(hover: hover)').matches ){
				return ['hover'];
			} else{
				return ['not-hover'];
			}
		})();

	}

	addClass() {
		/*
		 * addClass
		 * bodyにクラスを付与
		 */
		const body = document.body;
		const prefix = 'ua-';


		if (this.options['deviceType'] === true && this.ua.deviceType !== -1) {
			for (let i = 0; i < this.ua.deviceType.length; i++) {
				body.classList.add(prefix + this.ua.deviceType[i]);
			}
		}
		if (this.options['device'] === true && this.ua.device !== -1) {
			for (let i = 0; i < this.ua.device.length; i++) {
				body.classList.add(prefix + this.ua.device[i]);
			}
		}
		if (this.options['browser'] === true && this.ua.browser !== -1) {
			for (let i = 0; i < this.ua.browser.length; i++) {
				body.classList.add(prefix + this.ua.browser[i]);
			}
		}
		if (this.options['display'] === true && this.ua.display !== -1) {
			for (let i = 0; i < this.ua.display.length; i++) {
				body.classList.add(prefix + this.ua.display[i]);
			}
		}
		if (this.options['hover'] === true && this.ua.hover !== -1) {
			for (let i = 0; i < this.ua.hover.length; i++) {
				body.classList.add(prefix + this.ua.hover[i]);
			}
		}
	}

	check() {
		/*
		 * 確認用
		 * タブレット、スマホでも確認できるように、アラートで表示
		 */
		let check = '';

		for (let i = 0; i < this.ua.deviceType.length; i++) {
			check += this.ua.deviceType[i] + ' , ';
		}
		for (let i = 0; i < this.ua.device.length; i++) {
			check += this.ua.device[i] + ' , ';
		}
		for (let i = 0; i < this.ua.browser.length; i++) {
			check += this.ua.browser[i] + ' , ';
		}
		for (let i = 0; i < this.ua.display.length; i++) {
			check += this.ua.display[i] + ' , ';
		}
		for (let i = 0; i < this.ua.hover.length; i++) {
			check += this.ua.hover[i] + ' , ';
		}

		alert(check);
	}
}

window.uaLite = uaLite;
